{
  "validEmailsTitle": "Gültige E-Mails/Domains",
  "newEmailPlaceholder": "Neue E-Mail/Domain",
  "addButton": "Neu",
  "emailToTestPlaceholder": "E-Mail zum Testen",
  "testButton": "Test",
  "testPassed": "Bestanden. Diese E-Mail erhält Zugriff.",
  "testFailed": "Fehlgeschlagen. Diese E-Mail-Adresse erhält keinen Zugriff.",
  "passwordWhitelistTitle": "Passwort-Authentifizierung Whitelist",
  "newEmailWhitelistPlaceholder": "Neue E-Mail",
  "defaultReason": "Über Admin-UI hinzugefügt",
  "whitelistTestPassed": "Bestanden. Diese E-Mail kann Passwort-Authentifizierung verwenden.",
  "whitelistTestFailed": "Fehlgeschlagen. Diese E-Mail erfordert Microsoft/Google-Anmeldung."
}
